import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import {
  BASE_MOBILE_API_URL,
  PROJECT_CUSTOMER_NAME,
  PROJECT_DELIVERY_NAME,
  BASIC_AUTH,
} from "../../constants";
import { Link, useNavigate, useLocation } from "react-router-dom";
import ButtonSpinner from "../Spinner/ButtonSpinner";
import { notifyError, notifySuccess } from "../notify";
import axios from "axios";
import Loader from "../Spinner/logoLoader";

const Sidebar = ({ isVisible, onForceToggle }) => {
  const navigate = useNavigate();
  const loginUserType = localStorage.getItem("loginusertype");
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showChangePass, setShowChangePass] = useState(false);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [passLoading, setPassLoading] = useState(false);
  const [passErrors, setPassErrors] = useState({});

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [showOld, setShowOld] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const sidebarRef = useRef(null);
  const no_ref = useRef(null);

  useEffect(() => {
    if (showLogoutModal) {
      const timer = setTimeout(() => {
        if (no_ref.current) {
          no_ref.current.focus();
        }
      }, 50);

      return () => clearTimeout(timer); // cleanup (good practice)
    }
  }, [showLogoutModal]);

  useEffect(() => {
    if (isVisible && sidebarRef.current) {
      import("perfect-scrollbar").then((PerfectScrollbar) => {
        const ps = new PerfectScrollbar.default(sidebarRef.current);
        return () => ps.destroy();
      });
    }
  }, [isVisible]);

  const oldpassRef = useRef(null);
  useEffect(() => {
    if (showChangePass && oldpassRef.current) {
      oldpassRef.current.focus();
    }
  }, [showChangePass]);

  const handleLogout = async () => {
    setLogoutLoading(true);
    localStorage.removeItem("loginuser");
    sessionStorage.removeItem("loginuser");
    localStorage.removeItem("user");
    localStorage.removeItem("company");
    localStorage.removeItem("customerInfo");

    if (loginusertype === "customer") {
      localStorage.removeItem("itemCategoryMaster");
      localStorage.removeItem("itemMaster");
      localStorage.removeItem("branchItemRateMaster");
      localStorage.removeItem("customerItemRateMaster");
      localStorage.removeItem("deliveryTimeSlot");
    }
    navigate("/signin");
    setLogoutLoading(false);
  };

  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  const companyStr = localStorage.getItem("company");
  const company = companyStr ? JSON.parse(companyStr) : null;

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  const loginusertype = localStorage.getItem("loginusertype");

  const location = useLocation();
  const isDashboardActive = location.pathname === "/dashboard";
  const isDeliveredOrdersActive =
    location.pathname === "/delivered_orders_history";
  const isPurchaseHistoryActive = location.pathname === "/purchase_history";
  const isOrderHistoryActive = location.pathname === "/order_history";
  const isChangeShopActive = location.pathname === "/change_shop";
  const isSyncMasterActive = location.pathname === "/sync_master";
  const isOffersActive = location.pathname === "/offers";
  const isAddressActive = location.pathname === "/address_master";
  const isSupportActive = location.pathname === "/support";
  const isLedgerActive = location.pathname === "/ledger";
  const isChangePassActive = showChangePass;

  const handleMenuClick = () => {
    if (window.innerWidth <= 768) {
      // Mobile breakpoint
      onForceToggle();
    }
  };

  const resetPassFields = () => {
    setOldPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setShowConfirm(false);
    setShowNew(false);
    setShowOld(false);
  };
  const handleChnagePassword = async () => {
    const errors = {};

    // Required checks
    if (!oldPassword.trim()) {
      errors.oldPassword = "Old password is required";
    }

    if (!newPassword.trim()) {
      errors.newPassword = "New password is required";
    }

    if (!confirmPassword.trim()) {
      errors.confirmPassword = "Confirm password is required";
    }

    // New password must be different from old
    if (oldPassword && newPassword && oldPassword === newPassword) {
      errors.newPassword = "New password must be different from old password";
    }

    // Confirm password must match new password
    if (newPassword && confirmPassword && newPassword !== confirmPassword) {
      errors.confirmPassword = "New password & confirm password do not match";
    }

    // If errors exist → stop
    if (Object.keys(errors).length > 0) {
      setPassErrors(errors);
      return;
    }

    setPassLoading(true);
    try {
      const response = await axios.post(
        `${BASE_MOBILE_API_URL}/customer_change_password`,
        {
          companycode: customer?.companycode,
          branchcode: customer?.branchcode,
          customercode: customer?.customercode,
          old_password: oldPassword,
          new_password: newPassword,
        },
        {
          headers: {
            Authorization: BASIC_AUTH,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        // If all valid
        setPassErrors({});
        setShowChangePass(false);
        notifySuccess("Password changed successfully!");
        resetPassFields();
      }
    } catch (err) {
      console.error(err);

      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Change passward failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setPassLoading(false);
    }
  };

  const [loading, setLoading] = useState(false);

  const hasSynced = useRef(false);

  const handleSyncMaster = useCallback(async () => {
    setLoading(true);

    const customerStr = localStorage.getItem("customerInfo");
    const customer = customerStr ? JSON.parse(customerStr) : null;

    const apis = [
      {
        url: "/get_item_cat_master",
        key: "itemCategoryMaster",
        params: {
          companycode: customer?.companycode,
          supervisorcode: "0",
          branchcode: customer?.branchcode,
        },
      },
      {
        url: "/get_item_master",
        key: "itemMaster",
        params: {
          companycode: customer?.companycode,
          supervisorcode: "0",
          branchcode: customer?.branchcode,
        },
      },
      {
        url: "/get_branch_item_rate_master",
        key: "branchItemRateMaster",
        params: {
          companycode: customer?.companycode,
          branchcode: customer?.branchcode,
          itemcode: "0",
        },
      },
      {
        url: "/get_customer_item_rate_master",
        key: "customerItemRateMaster",
        params: {
          companycode: customer?.companycode,
        },
      },
      {
        url: "/get_delivery_time_slot",
        key: "deliveryTimeSlot",
        params: {
          companycode: customer?.companycode,
          supervisorcode: "0",
          branchcode: customer?.branchcode,
        },
      },
    ];

    try {
      for (let api of apis) {
        const response = await axios.get(`${BASE_MOBILE_API_URL}${api.url}`, {
          headers: { Authorization: BASIC_AUTH },
          params: api.params, // dynamic params here
        });

        localStorage.setItem(api.key, JSON.stringify(response.data));
      }

      notifySuccess("Master Data Synced Successfully");
    } catch (error) {
      console.error(error);
      notifyError("Sync failed ");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (loginusertype !== "customer") return; // stop here if not customer

    const checkAndSyncMaster = async () => {
      const requiredKeys = [
        "itemCategoryMaster",
        "itemMaster",
        "branchItemRateMaster",
        "customerItemRateMaster",
        "deliveryTimeSlot",
      ];

      const isAnyMissing = requiredKeys.some(
        (key) => !localStorage.getItem(key),
      );

      if (isAnyMissing) {
        await handleSyncMaster();
      }
    };

    if (!hasSynced.current) {
      hasSynced.current = true;
      checkAndSyncMaster();
    }
  }, [handleSyncMaster, loginusertype]); // add loginusertype

  return (
    <>
      {loading && <Loader message="Syncing Data..." />}
      {isVisible && (
        <div
          className="sidebar-overlay"
          onClick={onForceToggle} // Close sidebar when clicking outside
        ></div>
      )}
      <aside
        ref={sidebarRef}
        className={`sidenav ${isVisible ? "open" : "closed"}`}
        id="sidenav-main"
        style={{
          width: "250px",
          zIndex: 1050,
          overflow: "hidden", // avoids white flash on Moto
        }}
      >
        <div className="sidenav-header shadow-sm  w-100 text-center py-2 pt-1 pb-2">
          <div style={{ opacity: isVisible ? 1 : 0 }}>
            <button
              className="sidebar-close-arrow"
              onClick={(e) => {
                e.stopPropagation();
                onForceToggle();
              }}
              title="Close Sidebar"
            >
              <i
                className="fa-solid fa-arrow-left p-2 text-white font-16"
                onClick={(e) => {
                  e.stopPropagation();
                  onForceToggle();
                }}
              ></i>
            </button>

            {/* Project Name */}
            <div className="project-name font-weight-bold mb-8 ">
              {loginUserType === "delivery"
                ? PROJECT_DELIVERY_NAME
                : PROJECT_CUSTOMER_NAME}
            </div>
            {/* Logo */}
            <Link
              to="/dashboard"
              title="Go To Dashboard"
              onClick={() => {
                if (window.innerWidth <= 768) {
                  onForceToggle();
                }
              }}
            >
              <Image
                width={55}
                height={50}
                src={
                  loginusertype === "customer"
                    ? customer?.company_image
                    : company?.cmp_image
                }
                alt="main_logo"
                className="mb-2"
              />
            </Link>
            <hr className="text-white mt-0" />
            <div className="text-sm font-weight-bold mb-2 text-theme">
              <b>
                {" "}
                Company :{" "}
                {loginusertype === "customer"
                  ? customer?.companyname
                  : company?.com_name}{" "}
              </b>
            </div>
            {loginUserType === "customer" && (
              <div className="text-sm font-weight-bold mb-2 text-theme">
                <b>
                  {" "}
                  Branch :{" "}
                  {loginusertype === "customer"
                    ? customer?.branchname
                    : user?.branchname}
                </b>
              </div>
            )}
            <div className="text-sm font-weight-bold mb-2 text-theme">
              <b>
                {" "}
                Name :{" "}
                {loginusertype === "customer" ? customer?.name : user?.name}
              </b>
            </div>
            {loginusertype === "customer" && (
              <div className="text-sm font-weight-bold mb-2 text-theme">
                <b>
                  {" "}
                  Customer Type :{" "}
                  {customer?.customertype === "C"
                    ? "Credit"
                    : customer?.customertype === "A"
                      ? "Advance"
                      : customer?.customertype}
                </b>
              </div>
            )}
            <hr className="text-white mb-0" />
          </div>
        </div>
        {/* )} */}

        {/* Navigation Links */}
        <div
          className="nav-links w-100 mt-2"
          style={{ opacity: isVisible ? 1 : 0 }}
        >
          <ul className="navbar-nav d-flex flex-column align-items-stretch">
            <li className="nav-item">
              <Link
                className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
      ${isDashboardActive ? "nav-active" : ""}`}
                style={{ cursor: "pointer" }}
                to="/dashboard"
                onClick={handleMenuClick}
              >
                <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-chart-line"></i>
                Dashboard
              </Link>
            </li>

            {loginUserType === "delivery" && (
              <>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
      ${isDeliveredOrdersActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/delivered_orders_history"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-circle-check mt-md-2"></i>
                    Delivered Order History
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
     ${isSupportActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/support"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-headset"></i>
                    Support
                  </Link>
                </li>
              </>
            )}
            {loginUserType === "customer" && (
              <>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
     ${isChangePassActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowChangePass(true)}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-lock"></i>
                    Change Password
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
      ${isChangeShopActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/change_shop"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-store "></i>
                    Change Shop
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
      ${isPurchaseHistoryActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/purchase_history"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-box "></i>
                    Purchase History
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
      ${isOrderHistoryActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/order_history"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-box "></i>
                    Order History
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
      ${isLedgerActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/ledger"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-file "></i>
                    Ledger
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
     ${isOffersActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/offers"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-tags"></i>
                    Offers
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
     ${isSyncMasterActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    onClick={handleSyncMaster}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-arrows-rotate "></i>
                    Sync Master
                  </Link>
                </li>
                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
     ${isAddressActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/address_master"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-location-dot"></i>
                    Address Master
                  </Link>
                </li>

                <li className="nav-item mt-2">
                  <Link
                    className={`nav-link py-2 fw-bold text-start px-3  d-flex align-items-stretch 
     ${isSupportActive ? "nav-active" : ""}`}
                    style={{ cursor: "pointer" }}
                    to="/support"
                    onClick={handleMenuClick}
                  >
                    <i className="icon icon-shape icon-sm shadow border-radius-md me-2 fa-solid fa-headset"></i>
                    Support
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
        <button
          className=" sidebar-logout-btn  mx-2 mt-2"
          onClick={() => setShowLogoutModal(true)}
        >
          <i className="fa-solid fa-right-from-bracket me-2 "></i> Logout
        </button>

        {/* )} */}
      </aside>

      <Modal
        show={showChangePass}
        onHide={() => {
          setShowChangePass(false);
          resetPassFields();
        }}
        backdrop="static" // ❌ Prevent outside click close
        keyboard={false} // ❌ Prevent Esc key close
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Change Password</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {/* Old Password */}
            <div className="mb-1 position-relative ">
              <label className="form-label ">
                Enter Old Password <span className="red-error">*</span>
              </label>
              <input
                ref={oldpassRef}
                type={showOld ? "text" : "password"}
                className="form-control"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                placeholder="Enter Old Password"
              />
              <button
                type="button"
                className="change_password_eye"
                onClick={() => setShowOld(!showOld)}
              >
                <span className="material-icons">
                  {showOld ? "visibility_off" : "visibility"}
                </span>
              </button>
            </div>
            {passErrors.oldPassword && (
              <div className="text-danger small">{passErrors.oldPassword}</div>
            )}
            {/* New Password */}
            <div className="mb-1 position-relative ">
              <label className="form-label ">
                Enter New Password <span className="red-error">*</span>
              </label>
              <input
                type={showNew ? "text" : "password"}
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter New Password"
              />
              <button
                type="button"
                className="change_password_eye"
                onClick={() => setShowNew(!showNew)}
              >
                <span className="material-icons">
                  {showNew ? "visibility_off" : "visibility"}
                </span>
              </button>
            </div>
            {passErrors.newPassword && (
              <div className="text-danger small">{passErrors.newPassword}</div>
            )}
            {/* Confirm Password */}
            <div className="mb-1 position-relative ">
              <label className="form-label ">
                Enter Confirm Password <span className="red-error">*</span>
              </label>
              <input
                type={showConfirm ? "text" : "password"}
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Enter Confirm New Password"
              />
              <button
                type="button"
                className="change_password_eye"
                onClick={() => setShowConfirm(!showConfirm)}
              >
                <span className="material-icons">
                  {showConfirm ? "visibility_off" : "visibility"}
                </span>
              </button>
            </div>
            {passErrors.confirmPassword && (
              <div className="text-danger small">
                {passErrors.confirmPassword}
              </div>
            )}
          </Modal.Body>

          <Modal.Footer>
            <ButtonSpinner
              type="button"
              variant="success"
              className="btn btn-success"
              loading={passLoading}
              onClick={handleChnagePassword}
            >
              {passLoading ? "Submitting..." : "Submit"}
            </ButtonSpinner>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showLogoutModal}
        onHide={() => setShowLogoutModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Logout Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to logout?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="danger"
              ref={no_ref}
              onClick={() => setShowLogoutModal(false)}
              className="no-btn"
            >
              No
            </Button>
            <ButtonSpinner
              type="submit"
              variant="success"
              className="btn btn-success  "
              loading={logoutLoading}
              onClick={handleLogout}
            >
              {logoutLoading ? "Progress..." : "Yes"}
            </ButtonSpinner>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default Sidebar;
